//core
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {dashboardService} from "../../../services/affiliate/dashboard.service";
import {ActionReducerMapBuilder} from "@reduxjs/toolkit/src/mapBuilders";
import {NoInfer} from "@reduxjs/toolkit/src/tsHelpers";
import {setUser} from "../../common/user";

export type personalChief = {
  chief: {
    email: string,
    name: string,
    teams: string,
  }
  stats: {
    statistics: {

    }
  }
}

type statisticsItem = {
  clicks_count: number | string,
  views_count: number | string,
  registration_count: number | string,
  clien_count: number | string,
  profit: number | string,
}

export type dashboardStats = {
  statistics: {
    today: statisticsItem,
    yesterday: statisticsItem,
    week: statisticsItem,
    last_week: statisticsItem,
    month: statisticsItem,
    last_month: statisticsItem,
  },
  chart: {
    by_day: object,
    by_months: object,
  },
  date_update_statistic: string,
  locale_key_chart: string,
}

export type dashboardSliceState = {
  personalChief: {
    data: personalChief | null,
    error: any,
    isFetching: boolean,
  }
  stats: {
    data: dashboardStats | null,
    error: any,
    isFetching: boolean,
  }
}

const initialState: dashboardSliceState = {
  personalChief: {
    data: null,
    error: null,
    isFetching: false,
  },
  stats: {
    data: null,
    error: null,
    isFetching: false,
  }
}

export const getPersonalChiefData: any = createAsyncThunk(
  'dashboard/personalChief',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await dashboardService.getPersonalChief();
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        return rejectWithValue(data)
      }

      return data;
    } catch (error) {
      return rejectWithValue(error)
    }
  }
);

export const getStatsData: any = createAsyncThunk(
  'dashboard/stats',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await dashboardService.getStats();
      const data = await response.json();
      //const data = {...response};

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        return rejectWithValue(data)
      }

      return data;
    } catch (error) {
      return rejectWithValue(error)
    }
  }
);

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {
    clearStatsState(state) {
      state.stats.data = null;
      state.stats.error = null;
      state.stats.isFetching = false;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<dashboardSliceState>>) => {
    builder.addCase(getPersonalChiefData.pending, (state ) => {
      state.personalChief.isFetching = true;
      state.personalChief.error = null;
    });
    builder.addCase(getPersonalChiefData.fulfilled, (state , action) => {
      state.personalChief.error = null;
      state.personalChief.isFetching = false;
      state.personalChief.data = action.payload;
    });
    builder.addCase(getPersonalChiefData.rejected, (state , action) => {
      state.personalChief.error = action.payload;
    });

    builder.addCase(getStatsData.pending, (state ) => {
      state.stats.isFetching = true;
      state.stats.error = null;
    });
    builder.addCase(getStatsData.fulfilled, (state , action) => {
      state.stats.error = null;
      state.stats.isFetching = false;
      state.stats.data = action.payload;
    });
    builder.addCase(getStatsData.rejected, (state , action) => {
      state.stats.error = action.payload;
    });
  }
})

export default dashboardSlice.reducer;

export const {
  clearStatsState,
} = dashboardSlice.actions;
